import { c as _c } from "react/compiler-runtime";
import { MonetizableStarRatingTooltip } from './Monetizable';
import { NotMonetizableStarRatingTooltip } from './NotMonetizable';
import type { StarRatingTooltipProps } from './types';
export function StarRatingTooltip(t0) {
  const $ = _c(4);
  const {
    isMonetizing,
    segmentActionSection,
    popupCss
  } = t0;
  let t1;
  if ($[0] !== isMonetizing || $[1] !== popupCss || $[2] !== segmentActionSection) {
    t1 = isMonetizing ? <MonetizableStarRatingTooltip segmentActionSection={segmentActionSection} popupCss={popupCss} /> : <NotMonetizableStarRatingTooltip segmentActionSection={segmentActionSection} popupCss={popupCss} />;
    $[0] = isMonetizing;
    $[1] = popupCss;
    $[2] = segmentActionSection;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}